import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../config/api';

function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await api.get('/testimonials');
        const data = response.data;

        if (data.success && Array.isArray(data.data)) {
          setTestimonials(data.data);
        } else {
          setTestimonials([]);
        }
      } catch (error) {
        console.error('Error fetching testimonials:', error);
        setTestimonials([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  return (
    <div className="testimonials-page">
      {/* Page Header */}
      <section className="page-header py-40 rpy-30" style={{ background: '#f8f9fa', paddingTop: '60px', paddingBottom: '40px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-content text-center" style={{ marginTop: '60px' }}>
                <h1 className="page-title" style={{ fontSize: '48px', fontWeight: 700, color: '#111827', marginBottom: '12px' }}>
                  All Customer Reviews
                </h1>
                <p className="page-subtitle" style={{ fontSize: '18px', color: '#6B7280', margin: 0 }}>
                  {testimonials.length > 0 
                    ? `${testimonials.length} people have shared their experience with AcuIT`
                    : 'Read what our customers say about us'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section-new" style={{ paddingTop: '40px', paddingBottom: '80px' }}>
        <div className="container">
          {loading ? (
            <div className="text-center py-5">
              <p>Loading testimonials...</p>
            </div>
          ) : testimonials.length > 0 ? (
            <div className="testimonials-grid-wrap">
              {testimonials.map((testimonial, index) => {
                if (!testimonial || !testimonial.id) return null;

                const uniqueKey = `testimonial-${testimonial.id}-${index}`;
                const rating = testimonial.rating || 5;
                const authorTitle = testimonial.designation 
                  ? `${testimonial.designation}${testimonial.company ? ` at ${testimonial.company}` : ''}`
                  : testimonial.company || '';

                return (
                  <div key={uniqueKey} className="testimonial-card-new">
                    {/* Review Text */}
                    <div className="testimonial-review-text">
                      <p>
                        {testimonial.testimonial
                          ? testimonial.testimonial.replace(/&nbsp;/g, ' ')
                          : ''}
                      </p>
                    </div>

                    {/* Rating Section */}
                    <div className="testimonial-rating-new">
                      <div className="rating-stars">
                        {Array.from({ length: 5 }).map((_, starIndex) => {
                          const starNumber = starIndex + 1;
                          const isFilled = starNumber <= rating;
                          return (
                            <i
                              key={starIndex}
                              className={`fas fa-star ${
                                isFilled ? 'star-filled' : 'star-empty'
                              }`}
                            />
                          );
                        })}
                      </div>
                      <span className="rating-badge">{rating}/5</span>
                    </div>

                    {/* Author Section */}
                    <div className="testimonial-author-new">
                      <div className="author-avatar">
                        <img
                          src={testimonial.image || '/assets/images/team/default-avatar.svg'}
                          alt={testimonial.name || 'Author'}
                          onError={(e) => {
                            e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"%3E%3Ccircle cx="24" cy="24" r="24" fill="%23E5E7EB"/%3E%3Cpath d="M24 24c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm0 4c-5.3 0-16 2.7-16 8v4h32v-4c0-5.3-10.7-8-16-8z" fill="%23999"/%3E%3C/svg%3E';
                          }}
                        />
                      </div>
                      <div className="author-info">
                        <h3 className="author-name">
                          {testimonial.name || 'Unknown'}
                        </h3>
                        <p className="author-title">{authorTitle}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="text-center py-5">
              <p>No testimonials available at the moment.</p>
              <Link to="/" className="btn-check-reviews" style={{ marginTop: '20px', textDecoration: 'none', display: 'inline-block' }}>
                Back to Home
              </Link>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default Testimonials;

